import type { CheckAccount } from '../type';

export const CheckAccountDto = Symbol.for('CheckAccountDto');

export interface CheckAccountDto {
  checkAccount(email: string, isLogin: boolean): Promise<CheckAccount>;
}
